import { IPageProps } from '@ucheba/utils/helpers/components/types'
import { INavigationProps } from '@ucheba/ui/components/Navigation/types'
import { IPropHref, IPropId } from '@ucheba/utils/helpers/components/prop.types'
import { IEventsFacets, IEventsSearchItem } from '@ucheba/store/events/search/types'
import { IFacet } from '@ucheba/utils/types/search'
import { EProgramTypes } from '@ucheba/utils/types/program'

export interface IEventsPageProps extends IPageProps<IContent> {}

export interface IContent {}

export interface IEventsPageRegisterNotice extends Required<IPropId<number>>, IPropHref {
  open: boolean
  isEventStarted?: any
}

export interface IUseEventsPageHeaderCore {
  (): {
    title: string
    items?: INavigationProps['items']
    activeIndex: number
    onClick?: (_, slug: string) => void
    events?: IEventsSearchItem[]
  }
}

export interface ISectionsNavigationItem {
  name: string
  slug: string | string[]
  href?: string
}

export interface IUseEventsSearchPageFacetsCore {
  (props?: { durationDebounced?: number }): {
    facets: IEventsFacets | null | undefined
    onSubmit(facetName: string): (checked: string | string[] | undefined) => void
    updateRouter(params: Record<string, any>): void
  }
}

export interface IUseEventsPageSelectedFacetsCore {
  (): {
    selectedFacets: TUseEventsPageSearchSelectedFacetsItem[]
    removeFacet: (queryKey: string, id: string) => void
  }
}

export interface IEventsPageHeader {}

export interface IUseTitleWithQuery {
  (query: any): {
    titleWithQuery: string
    descriptionWithQuery: string
    years: string
    isIndexAndFollow: boolean
  }
}

export type TUseEventsPageSearchSelectedFacetsItem = IFacet & {
  queryKey: string
}

export enum EEventsQueryParams {
  formatsIds = 'formats',
  locationIds = 'locationIds',
  programTypes = 'programTypes',
}

export interface IEventsQueryParams {
  query: {
    [EEventsQueryParams.formatsIds]?: string[]
    [EEventsQueryParams.locationIds]?: string[]
    [EEventsQueryParams.programTypes]?: string[]
  }
}

export interface EEventProgramTypes {
  [EProgramTypes.master]: string
  [EProgramTypes.course]: string
  [EProgramTypes.mba]: string
  [EProgramTypes.aspirant]: string
}
